(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["morocco-storefront"] && !Shopify.designMode) return;
  try {
    const openMoroccoEmailDialog = (trigger) => {
    const dialogId = trigger.getAttribute('aria-controls');
    const dialog = document.getElementById(dialogId);

    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
  };

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-morocco-email-open]');
    const closeTrigger = event.target.closest('[data-morocco-email-close]');

    if (openTrigger) {
      openMoroccoEmailDialog(openTrigger);
    }

    if (closeTrigger) {
      closeTrigger.closest('dialog')?.close();
    }

    if (event.target.matches('[data-morocco-email-dialog]')) {
      event.target.close();
    }
  });

  document.querySelectorAll('[data-morocco-email-auto-open="true"]').forEach((marker) => {
    const dialog = marker.closest('[data-morocco-email-dialog]');

    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
